module.exports = __webpack_public_path__ + "static/ankur_-69561148f32e792f3fdb5b04099616f2.png";